module.exports = __webpack_public_path__ + "static/img/jianzhu03.5c2d396.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/jianzhu03.png
// module id = 59/c
// module chunks = 12